import styled from '@emotion/styled';

const Logo = styled.img`
    box-sizing: border-box;
    height: var(--rwl-header-height);
    align-self: stretch;
    object-fit: contain;
    padding: var(--rwl-spacing-sm) var(--rwl-spacing-md);
    max-width: 160px;
`;

interface HeaderLogoProps {
    url?: string;
    name: string;
}

export const HeaderLogo = ({ url, name }: HeaderLogoProps) => {
    if (!url) {
        return null;
    }
    return <Logo src={url} alt="logo" aria-details={`Logo of ${name}`} />;
};
